<template>
  <div class="form-group">
    <label
      :for="field.id"
      class="form-label"
      :class="{ 'text-danger': !!field.error }"
      >{{ field.name + (field.required && '*') }}
      <Tooltip
        v-show="!!field.tooltipInfo"
        :id="field.id"
        :info="field.tooltipInfo"
      />
    </label>
    <div class="d-flex align-items-center justify-content-between mt-2">
      <input
        type="range"
        class="form-control-range"
        :id="field.id"
        @input="onInput"
        :min="min"
        :max="max"
        :value="field.value"
        ref="input"
      />
      <span class="d-block number-box__container">
        <input
          type="number"
          class="form-control number-box__input"
          @input="onInput"
          :value="field.value"
        />
      </span>
    </div>
    <div v-if="field.value > 2500">
      <span class="error mt-2">
        {{ field.error }}
        <a
          href=" https://www.citrix.com/products/citrix-virtual-apps-and-desktops/form/inquiry/"
          >Talk to an expert
        </a>
      </span>
    </div>
    <div v-else-if="!!field.error" class="error mt-2">
      {{ field.error }}
      <a
        href=" https://www.citrix.com/products/citrix-virtual-apps-and-desktops/form/inquiry/"
        >Talk to an expert
      </a>
    </div>
  </div>
</template>

<script>
import Tooltip from '../global/Tooltip.vue';

export default {
  name: 'Slider',
  props: {
    field: {
      type: Object,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
  mounted() {
    const percent = this.calcPercentage(this.field.value);
    this.$refs.input.style.background = `linear-gradient(0.25turn, #36C2CC 0% ${percent.left}%, #D9D9D9 ${percent.left}%)`;
  },
  updated() {
    if (this.field.value > 2500) {
      this.field.error = '2500+ users? Enjoy discounted volume pricing.';
    } else if (this.field.value < 50) {
      this.field.error =
        'Have < 50 users? We can help with your small or medium business needs.';
    } else {
      this.field.error = null;
    }
    const percent = this.calcPercentage(this.field.value);
    this.$refs.input.style.background = `linear-gradient(0.25turn, #36C2CC 0% ${percent.left}%, #D9D9D9 ${percent.left}%)`;
  },
  methods: {
    calcPercentage(val) {
      const currentValueInt = parseInt(val);
      const range = Math.abs(this.min - this.max);
      const leftPercent = Math.round(
        (Math.abs(currentValueInt - this.min) / range) * 100
      );
      const rightPercent = 100 - leftPercent;

      return { left: leftPercent, right: rightPercent };
    },

    onInput($event) {
      const percent = this.calcPercentage($event.target.value);

      this.$refs.input.style.background = `linear-gradient(0.25turn, #36C2CC 0% ${percent.left}%, #D9D9D9 ${percent.left}%)`;

      this.$emit('input', $event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #05758a;
  border-bottom: none;
}

@mixin thumb-rules {
  width: 18px;
  height: 18px;
  background: $primary;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.15);
}

.form-control-range {
  -webkit-appearance: none;
  appearance: none;
  border: none;
  height: 5px;
  color: #000;
  border-radius: 3px;
  opacity: 1;
  transition: opacity 0.2s;
  background: rgba(0, 0, 0, 0.15);

  &:hover {
    opacity: 0.7;
  }

  // chrome
  &::-webkit-slider-thumb {
    appearance: none;
    @include thumb-rules;
  }

  &::-moz-range-thumb {
    @include thumb-rules;
  }
}
input:focus,
select:focus {
  outline: none !important;
}
.number-box {
  &__container {
    padding-left: 26px;
  }
  &__input {
    width: 114px;
    height: 42px;
    border: 0.5px solid #b1b1b1;
    box-sizing: border-box;
    border-radius: 2px;
    font-size: 16px;
  }
}

.form-label {
  font-size: 20px;
  line-height: 22px;
}
.error {
  font-size: 17px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  color: #000;
}
</style>
